
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host{

  display:block;

  min-width:170px;

  border-radius:1rem;

  background-color:var(--neutral-white);
}@media (min-width: 768px){:host{

    min-width:261px;
  }
}:host{

  box-shadow:var(--brand-shadow);
}

.review-card{

  padding-top:1.5rem;

  padding-bottom:1.5rem;

  padding-left:1rem;

  padding-right:1rem;
}

.review-card__label{

  margin-bottom:0.75rem;

  border-bottom-width:1px;

  border-top-width:0px;

  border-left-width:0px;

  border-right-width:0px;

  border-style:solid;

  border-color:var(--neutral-gray-4);

  padding-bottom:0.5rem;

  text-align:center;

  font-weight:var(--fw-semibold);

  color:var(--primary-blue);
}

.review-card__content{

  display:flex;

  flex-direction:column;

  align-items:center;
}

.review-card__rate{

  margin-bottom:0.5rem;

  font-family:var(--ff-display);

  font-size:var(--fs-4xl);

  line-height:var(--lh-4xl);

  font-weight:var(--fw-bold);

  color:var(--neutral-gray);
}

@media (min-width: 768px){.review-card__rate{

    font-size:var(--fs-5xl);

    line-height:var(--lh-5xl);
  }
}
`;